import {Component, Input, OnInit} from '@angular/core';
import {Question} from "../question/question";
import {QuestionService} from "../question/question.service";

import {Avaliacao} from "./avaliacao";
import {Trabalho} from "../trabalho/trabalho";
import {forEach} from "@angular/router/src/utils/collection";
import {isNumber} from "util";
import {AcessoService} from "../acesso/acesso.service";
import {AvaliacaoService} from "./avaliacao.service";
import {Router} from "@angular/router";
import {AppComponent} from "../app.component";

declare var jQuery: any;

@Component({
    selector: 'app-avaliacao',
    templateUrl: './avaliacao.component.html',
    styleUrls: ['./avaliacao.component.css'],
    providers: [
        QuestionService,
        AvaliacaoService
    ]
})

export class AvaliacaoComponent extends AppComponent implements OnInit {
    questions: Question[];
    avaliacao: Avaliacao;
	trabalho: Trabalho;
    @Input('setdisabled') setdisabled: any;
    @Input('trab_id') trab_id: any;
    @Input('aval_id') aval_id: any;
    result_status: any;
    carregado: boolean = false;
    motivoStatus=false;
	numPerguntas: number = 14;
	q: any[];

    ngOnInit() {
        if (!this.isAdmin() && !this.isParecerista()) 
			this.router.navigateByUrl('inicio');
        else {
			this.trabalhoService.getTrabalho(this.trab_id).then(trabalho => {
				let i: number = this.numPerguntas;
				
				this.trabalho = trabalho;
				this.questionService.getQuestions(trabalho.evento_id).then(questions => this.setQuestions(questions));
				this.avaliacao = new Avaliacao;
				while (i-- > 0)
					this.avaliacao['Q' + i] = -1;
				
			});
		}
    }
    setAvaliacao(avaliacao){
        this.avaliacao=avaliacao;
        this.motivoStatus=true;
    }

    setQuestions(questions) {
        if (this.setdisabled == "true") {
			this.questions = questions;
            this.avaliacaoService.getAvaliacao(this.trab_id, this.aval_id).then(
                avaliacao=>this.setAvaliacao(avaliacao)
            )
        }
        this.questions = questions;
		
		
		let i: number = questions.length;
		let q = new Array(i);
		while (--i >= 0) 
			q[i] = new Array(questions[i].nota_maxima * 10 + 1);
		this.q = q;
		this.carregado = true;
    }

    change() {
        let total: number = 0;
        let avaliacao: Avaliacao = this.avaliacao;
		let i: number = this.questions.length + 1;
		let nota: number;
		
		while (--i > 0) {
			nota = Number(avaliacao['Q' + i]) * 10;
			total += (nota >= 0? nota : 0);
		}	
			
		this.result_status = "Nota " + total / 10;
    }


    onSubmit() {
        this.avaliacao.usuario_id = +sessionStorage.getItem('id');
        this.avaliacao.trabalho_id = this.trab_id;
		if (this.isAdmin()) {
			this.avaliacao.aprovada = false;
			if (this.avaliacao.motivo)
				this.avaliacao.motivo = (this.avaliacao.motivo + ' - ' + this.avaliacao.motivo_texto).toUpperCase();
		}
		this.avaliacaoService.save(this.avaliacao).then(response => this.redirect(response));	
	}

    onSubmitCorrection() {
        this.avaliacao.usuario_id = +sessionStorage.getItem('id');
        this.avaliacao.trabalho_id = this.trab_id;
        this.avaliacaoService.correction(this.avaliacao).then(response => this.redirect(response));
    }

    redirect(dados) {
        this.router.navigateByUrl("avaliacao");
    }

	ngAfterViewChecked() {
		if (this.isAdmin() || this.isParecerista()) {
			if (this.setdisabled == "true")
				jQuery("form :input").prop("disabled", true);
			this.change();
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/avaliacao/avaliacao.component.ts